import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { messages as EnMessages } from './localization-en'
import { messages as ThMessages } from './localization-th'
Vue.use(VueI18n)

export const messages = {
  en: EnMessages,
  th: ThMessages
}

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: 'th', // set locale
  messages // set locale messages
})



// WEBPACK FOOTER //
// ./src/lang/index.js